import Person2Icon from '@mui/icons-material/Person2';
import InfoIcon from '@mui/icons-material/Info';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import WidgetsIcon from '@mui/icons-material/Widgets';
import { LiaDumbbellSolid } from "react-icons/lia";

export const TRC_TAB_IDS = {
	ABOUT: 'about',
	GUEST_INSTRUCTOR: 'guest_instructor',
	RELATED: 'related',
	EQUIPMENT: 'equipment',
	CHAT: 'chat'
};

export const TRC_TAB_LABELS = {
	ABOUT: 'About',
	GUEST_INSTRUCTOR: 'Instructor',
	RELATED: 'Related',
	EQUIPMENT: 'Equipment',
	CHAT: 'Chat'
};

export const TRC_TAB_ICONS = {
	ABOUT: InfoIcon,
	GUEST_INSTRUCTOR: Person2Icon,
	RELATED: WidgetsIcon,
	EQUIPMENT: LiaDumbbellSolid,
	CHAT: QuestionAnswerIcon
};
